import SoftLinks from 'components/Catalog/SoftLinks/SoftLinks';

export default SoftLinks;
